<template>
  <div class="tournament-content-tab badge-print-root" v-bind:class="{'tournament-content-active-tab':activeTab == 12}">
    <div class="row">
      <div class="col-md-12">
        <card>
          <template slot="header">
            <div class="badge-toolbar no-print">
              <h4 class="title">Бейджі спортсменів ({{ badgeItems.length }})</h4>
              <div class="badge-actions">
                <button class="btn btn-sm btn-info btn-fill" @click="exportPdf" :disabled="badgeItems.length === 0 || isExportingPdf">
                  <tkd-icon name="download" style="vertical-align: sub;"/> {{ isExportingPdf ? 'Exporting...' : 'Export PDF' }}
                </button>
              </div>
            </div>
            <div class="export-progress" v-if="isExportingPdf">
              Export progress: {{ exportedCardsCount }} / {{ exportTotalCards }} cards
            </div>
            <div class="preview-pager" v-if="allPagedSportsmans.length > pagesPerView && !showAllPages">
              <button class="btn btn-sm btn-default btn-fill" @click="prevPageGroup" :disabled="currentPageGroup === 0">Prev</button>
              <span>Pages {{ currentPageGroup * pagesPerView + 1 }}-{{ Math.min((currentPageGroup + 1) * pagesPerView, allPagedSportsmans.length) }} of {{ allPagedSportsmans.length }}</span>
              <button class="btn btn-sm btn-default btn-fill" @click="nextPageGroup" :disabled="(currentPageGroup + 1) * pagesPerView >= allPagedSportsmans.length">Next</button>
            </div>
          </template>

          <div class="print-section" ref="printSection" v-if="badgeItems.length > 0" aria-label="Printable badge pages">
            <template v-for="(page, pageIndex) in visiblePagedSportsmans">
              <section class="print-page" :key="'page-' + pageIndex">
              <article
                class="badge"
                :data-badge-index="badgeIndex(pageIndex, personIndex)"
                v-for="(person, personIndex) in page"
                :key="person.id || ('person-' + pageIndex + '-' + personIndex)"
              >
                <div class="badge-local-actions no-print">
                  <button class="btn btn-xs btn-default btn-fill" @click="printSingleBadge($event)">Print</button>
                  <button class="btn btn-xs btn-info btn-fill" @click="exportSingleBadge($event)">PDF</button>
                </div>
                <header class="head">
                  <div class="head-right">
                    <p class="tournament-name">{{ tournamentNameForBadge }}</p>
                  </div>
                </header>

                <section class="main">
                  <p class="event-title" :class="{'event-title-template': isManualTemplate(person)}">
                    <template v-if="!isManualTemplate(person) && hasSlashSeparatedName(person.name)">
                      <span class="event-title-line" v-for="(line, lineIndex) in splitNameToRows(person.name)" :key="'name-line-' + lineIndex">{{ line }}</span>
                    </template>
                    <template v-else>
                      {{ isManualTemplate(person) ? '____________________' : (person.name || 'Не вказано') }}
                    </template>
                  </p>
                  <div class="category-chip" v-if="!isManualTemplate(person)">{{ person.category || 'Категорія не вказана' }}</div>
                  <div class="event-spacer"></div>

                  <div class="identity">
                    <div class="logo-column">
                      <div class="logo-wrap">
                        <img :src="badgeLogo" alt="Logo" />
                      </div>
                    </div>
                    <div class="logo-meta">
                      <span class="chip">{{ isManualTemplate(person) ? (person.templateChip || 'Тренер') : 'Спортсмен' }}</span>
                      <div class="logo-id" v-if="!isManualTemplate(person)">ID: {{ person.id || 'не вказано' }}</div>
                    </div>
                  </div>
                  <div class="person-data" v-if="!isManualTemplate(person)">
                    <div class="person-line"><span class="person-label">Область</span><span class="person-value">{{ person.oblast || 'не вказано' }}</span></div>
                    <div class="person-line"><span class="person-label">Рік народження</span><span class="person-value">{{ person.bdate || 'не вказано' }}</span></div>
                    <div class="person-line"><span class="person-label">Стать</span><span class="person-value">{{ formatSex(person.sex) }}</span></div>
                    <div class="person-line"><span class="person-label">Категорія</span><span class="person-value">{{ person.category || 'не вказано' }}</span></div>
                    <div class="person-line"><span class="person-label">Організація</span><span class="person-value">{{ person.organization || 'не вказано' }}</span></div>
                    <div class="person-line"><span class="person-label">Кваліфікація</span><span class="person-value">{{ person.qualification || 'не вказано' }}</span></div>
                    <div class="person-line"><span class="person-label">Тренер</span><span class="person-value">{{ person.coach || 'не вказано' }}</span></div>
                  </div>

                </section>
                <footer class="badge-bottom-logo">
                  <img :src="utfLogo" alt="UTF logo" />
                </footer>
              </article>
              </section>
              <hr
                v-if="pageIndex < visiblePagedSportsmans.length - 1"
                class="print-page-break"
                :key="'break-' + pageIndex"
              >
            </template>
          </div>
          <div v-else>Інформація відсутня</div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import badgeLogo from 'src/assets/badges/logo.png';
import utfLogo from 'src/assets/badges/utf-logo.png';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const PER_PAGE = 4;

export default {
  name: "tab-sportsmans-cards",
  data() {
    return {
      badgeLogo,
      utfLogo,
      isExportingPdf: false,
      exportTotalCards: 0,
      exportedCardsCount: 0,
      showAllPages: false,
      currentPageGroup: 0,
      pagesPerView: 6,
    };
  },
  computed: {
    activeTab() {
      return this.$store.getters['settings/activeTournamentTab'];
    },
    tournamentOne() {
      return this.$store.getters['tournament/tournamentOne'];
    },
    sportsmans() {
      if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.sportsmans) {
        return [];
      }
      return this.tournamentOne.data.item.sportsmans;
    },
    tournamentNameForBadge() {
      if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.name) {
        return 'Tournament';
      }
      return this.tournamentOne.data.item.name;
    },
    badgeItems() {
      const minCount = 20;
      const total = Math.max(this.sportsmans.length, minCount);
      const sportsmanItems = Array.from({length: total}, (_, index) => this.sportsmans[index] || {id: `demo-${index + 1}`});
      const trainerTemplates = Array.from({length: 4}, (_, index) => ({
        id: `template-trainer-${index + 1}`,
        templateType: 'manual',
        templateChip: 'Тренер',
      }));
      const sportsmanTemplates = Array.from({length: 4}, (_, index) => ({
        id: `template-sportsman-${index + 1}`,
        templateType: 'manual',
        templateChip: 'Спортсмен',
      }));
      return [
        ...trainerTemplates,
        ...sportsmanTemplates,
        ...sportsmanItems,
      ];
    },
    allPagedSportsmans() {
      const pages = [];
      for (let i = 0; i < this.badgeItems.length; i += PER_PAGE) {
        pages.push(this.badgeItems.slice(i, i + PER_PAGE));
      }
      return pages;
    },
    visiblePagedSportsmans() {
      if (this.showAllPages) {
        return this.allPagedSportsmans;
      }
      const start = this.currentPageGroup * this.pagesPerView;
      const end = start + this.pagesPerView;
      return this.allPagedSportsmans.slice(start, end);
    },
  },
  methods: {
    getRenderScale() {
      return Math.min(4, Math.max(2.5, (window.devicePixelRatio || 1) * 2));
    },
    getExportProfile(pageCount) {
      if (pageCount > 60) {
        return {scale: 1.35, imageType: 'JPEG', quality: 0.72, compression: true};
      }
      if (pageCount > 30) {
        return {scale: 1.6, imageType: 'JPEG', quality: 0.78, compression: true};
      }
      if (pageCount > 15) {
        return {scale: 1.9, imageType: 'JPEG', quality: 0.84, compression: true};
      }
      return {scale: this.getRenderScale(), imageType: 'PNG', quality: 1, compression: false};
    },
    isManualTemplate(person) {
      return !!(person && person.templateType);
    },
    hasSlashSeparatedName(name) {
      return typeof name === 'string' && name.indexOf('/') !== -1;
    },
    splitNameToRows(name) {
      if (typeof name !== 'string') {
        return ['Не вказано'];
      }
      const parts = name
        .split('/')
        .map((part) => part.trim())
        .filter(Boolean);

      if (parts.length <= 3) {
        return parts;
      }

      return [
        parts[0],
        parts[1],
        parts.slice(2).join(' / '),
      ];
    },
    getBadgeElementFromEvent(event) {
      if (!event || !event.currentTarget) {
        return null;
      }
      return event.currentTarget.closest('.badge');
    },
    prevPageGroup() {
      this.currentPageGroup = Math.max(0, this.currentPageGroup - 1);
    },
    nextPageGroup() {
      const maxGroup = Math.floor((this.allPagedSportsmans.length - 1) / this.pagesPerView);
      this.currentPageGroup = Math.min(maxGroup, this.currentPageGroup + 1);
    },
    withPrintMode(run) {
      document.body.classList.add('badges-print-mode');
      const cleanup = () => {
        document.body.classList.remove('badges-print-mode');
        this.showAllPages = false;
        window.removeEventListener('afterprint', cleanup);
      };
      window.addEventListener('afterprint', cleanup);
      run();
    },
    printAllBadges() {
      this.showAllPages = true;
      this.$nextTick(() => this.withPrintMode(() => window.print()));
    },
    printSingleBadge(event) {
      const badgeEl = this.getBadgeElementFromEvent(event);
      if (!badgeEl) {
        return;
      }
      badgeEl.classList.add('is-print-target');
      document.body.classList.add('single-badge-print-mode');
      this.withPrintMode(() => window.print());
      const cleanupSingle = () => {
        badgeEl.classList.remove('is-print-target');
        document.body.classList.remove('single-badge-print-mode');
        window.removeEventListener('afterprint', cleanupSingle);
      };
      window.addEventListener('afterprint', cleanupSingle);
    },
    async exportPdf() {
      if (this.isExportingPdf) {
        return;
      }

      this.isExportingPdf = true;
      try {
        if (document.fonts && document.fonts.ready) {
          await document.fonts.ready;
        }

        const printRoot = this.$refs.printSection;
        if (!printRoot) {
          return;
        }

        this.showAllPages = true;
        await this.$nextTick();

        const pages = Array.from(printRoot.querySelectorAll('.print-page'));
        if (pages.length === 0) {
          return;
        }
        this.exportTotalCards = pages.reduce((sum, page) => sum + page.querySelectorAll('.badge').length, 0);
        this.exportedCardsCount = 0;

        const profile = this.getExportProfile(pages.length);

        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: 'a4',
          compress: profile.compression,
        });

        for (let i = 0; i < pages.length; i += 1) {
          const cardsInPage = pages[i].querySelectorAll('.badge').length;
          const canvas = await html2canvas(pages[i], {
            backgroundColor: '#ffffff',
            scale: profile.scale,
            useCORS: true,
            allowTaint: true,
            imageTimeout: 0,
            ignoreElements: (el) => el.classList && el.classList.contains('no-print'),
          });

          const imageData = profile.imageType === 'JPEG'
            ? canvas.toDataURL('image/jpeg', profile.quality)
            : canvas.toDataURL('image/png');
          const pageWidth = 210;
          const pageHeight = 297;

          if (i > 0) {
            pdf.addPage('a4', 'portrait');
          }
          pdf.addImage(imageData, profile.imageType, 0, 0, pageWidth, pageHeight, undefined, 'MEDIUM');
          canvas.width = 0;
          canvas.height = 0;
          this.exportedCardsCount += cardsInPage;
          await this.$nextTick();
        }

        const safeName = (this.tournamentNameForBadge || 'badges')
          .replace(/[^\w\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
          .toLowerCase();
        pdf.save(`${safeName || 'badges'}-badges.pdf`);
      } finally {
        this.showAllPages = false;
        this.isExportingPdf = false;
        this.exportTotalCards = 0;
        this.exportedCardsCount = 0;
      }
    },
    async exportSingleBadge(event) {
      if (this.isExportingPdf) {
        return;
      }
      const badgeEl = this.getBadgeElementFromEvent(event);
      if (!badgeEl) {
        return;
      }

      this.isExportingPdf = true;
      try {
        if (document.fonts && document.fonts.ready) {
          await document.fonts.ready;
        }

        const canvas = await html2canvas(badgeEl, {
          backgroundColor: '#ffffff',
          scale: this.getRenderScale(),
          useCORS: true,
          allowTaint: true,
          imageTimeout: 0,
          ignoreElements: (el) => el.classList && el.classList.contains('no-print'),
        });

        const imageData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: 'a4',
          compress: false,
        });

        const badgeWidth = 90;
        const badgeHeight = 130;
        const x = (210 - badgeWidth) / 2;
        const y = (297 - badgeHeight) / 2;
        pdf.addImage(imageData, 'PNG', x, y, badgeWidth, badgeHeight);

        const idx = badgeEl.getAttribute('data-badge-index') || 'single';
        const safeName = (this.tournamentNameForBadge || 'badges')
          .replace(/[^\w\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
          .toLowerCase();
        pdf.save(`${safeName || 'badges'}-badge-${idx}.pdf`);
      } finally {
        this.isExportingPdf = false;
      }
    },
    badgeIndex(pageIndex, personIndex) {
      return (pageIndex * PER_PAGE) + personIndex + 1;
    },
    formatSex(sex) {
      if (String(sex) === '1') {
        return 'чоловік';
      }
      if (String(sex) === '2') {
        return 'жінка';
      }
      return 'не вказано';
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@500;700;800&display=swap');

.badge-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.badge-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.export-progress {
  margin-top: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #2f4f6f;
}

.badge-print-root {
  --primary: #006d5b;
  --primary-soft: #d4f7ef;
  --surface: #ffffff;
  --line: #c9d8d1;
  --text: #1a1f1d;
  --muted: #4e5b56;
  --a4-w: 210mm;
  --a4-h: 297mm;
  --badge-w: 90mm;
  --badge-h: 130mm;
  --gap: 8mm;
}

.print-section {
  display: grid;
  gap: 10px;
  justify-content: center;
  font-family: "Plus Jakarta Sans", "Segoe UI", sans-serif;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.print-page-break {
  display: none;
}

.print-page {
  width: var(--a4-w);
  min-height: var(--a4-h);
  padding: 14mm 12mm;
  border: 1px dashed #9eb0a8;
  background: #fff;
  display: grid;
  grid-template-columns: repeat(2, var(--badge-w));
  grid-auto-rows: var(--badge-h);
  column-gap: var(--gap);
  row-gap: 12mm;
  align-content: start;
  justify-content: center;
}

.badge {
  position: relative;
  width: var(--badge-w);
  height: var(--badge-h);
  padding: 0;
  border: 1px solid #d8ecff;
  background: var(--surface);
  display: grid;
  grid-template-rows: auto 1fr auto;
  overflow: hidden;
}

.head {
  background: #d8ecff;
  border-bottom: 1px solid #d8ecff;
  padding: 4.5mm 5mm;
  display: grid;
  grid-template-columns: 1fr;
  align-items: start;
  gap: 0;
}

.badge-local-actions {
  position: absolute;
  bottom: 1.6mm;
  right: 1.6mm;
  z-index: 3;
  display: flex;
  gap: 4px;
}

.head-right {
  min-width: 0;
  width: auto;
  max-width: none;
}

.tournament-name {
  display: block;
  margin: 0;
  width: 100%;
  font-size: 3.3mm;
  font-weight: 800;
  line-height: 1.2;
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
  hyphens: auto;
}

.chip {
  display: inline-block;
  font-size: 2.5mm;
  padding: 1mm 2mm;
  border-radius: 999px;
  background: #0066d2;
  color: #fff;
  font-weight: 800;
  text-transform: uppercase;
}

.main {
  height: 100%;
  padding: 2.6mm 3mm 0mm;
  display: grid;
  grid-template-rows: auto auto auto auto auto;
  align-content: start;
}

.event-title {
  margin: 0;
  font-size: 4.9mm;
  font-weight: 800;
  line-height: 1.1;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  hyphens: auto;
}

.event-title-line {
  display: block;
}

.event-title-template {
  min-height: 12mm;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  text-align: center;
}

.category-chip {
  display: inline-block;
  margin-top: 1.2mm;
  max-width: 100%;
  padding: 1.1mm 2.6mm;
  border-radius: 999px;
  background: #e6f0ff;
  color: #0f3f87;
  font-size: 3.3mm;
  font-weight: 700;
  line-height: 1.15;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.event-spacer {
  height: 2.4mm;
}

.identity {
  display: grid;
  grid-template-columns: 24mm 1fr;
  column-gap: 2.4mm;
  align-items: center;
  margin-bottom: 2mm;
}

.logo-wrap {
  width: 24mm;
  height: 24mm;
  border: 1px solid var(--line);
  background: #fff;
  overflow: hidden;
}

.logo-column {
  width: 24mm;
  padding-right: 1.6mm;
}

.logo-meta {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.2mm;
}

.logo-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.logo-id {
  margin-top: 1.2mm;
  font-size: 2.3mm;
  line-height: 1.2;
  color: var(--text);
  font-weight: 700;
  word-break: break-word;
}

.person-data {
  width: 100%;
  min-width: 0;
  border: 1px solid #dbe5ee;
  border-radius: 2mm;
  padding: 1.2mm 1.6mm;
  background: #f8fbff;
}

.person-line {
  margin: 0;
  display: grid;
  grid-template-columns: 38% 62%;
  column-gap: 1.6mm;
  font-size: 2.25mm;
  line-height: 1.3;
  color: var(--muted);
  align-items: start;
  padding: 0.9mm 0;
  border-bottom: 1px dashed #d1dce7;
}

.person-line:last-child {
  border-bottom: 0;
}

.person-label {
  color: #4b5c6b;
  font-weight: 700;
  text-align: left;
  letter-spacing: 0.01em;
}

.person-value {
  color: #1f2a36;
  text-align: left;
  font-weight: 600;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.badge-bottom-logo {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 0;
  min-height: 20mm;
  height: 20mm;
  padding-top: 1.5mm;
  padding-bottom: 4mm;
  overflow: hidden;
}

.badge-bottom-logo img {
  height: 100%;
  display: block;
}

@media screen and (max-width: 1200px) {
  .print-section {
    justify-content: start;
    overflow-x: auto;
    padding-bottom: 6px;
  }

  .print-page {
    width: var(--a4-w);
    min-height: var(--a4-h);
    padding: 14mm 12mm;
    border: 1px dashed #9eb0a8;
    grid-template-columns: repeat(2, var(--badge-w));
    grid-auto-rows: var(--badge-h);
    column-gap: var(--gap);
    row-gap: 12mm;
    justify-content: center;
  }

  .badge {
    width: var(--badge-w);
    height: var(--badge-h);
    min-height: 0;
  }
}

@media print {
  @page {
    size: A4 portrait;
    margin: 0;
  }

  .print-section {
    display: block;
    gap: 0;
  }

  .print-page {
    display: grid;
    border: 0;
    margin: 0;
    height: var(--a4-h);
    width: var(--a4-w);
    min-height: var(--a4-h);
    grid-template-columns: repeat(2, var(--badge-w));
    grid-auto-rows: var(--badge-h);
    padding: 14mm 12mm;
    page-break-inside: avoid;
    break-inside: avoid;
    row-gap: 12mm;
    overflow: hidden;
    page-break-after: always;
    break-after: page;
  }

  .print-page:last-child {
    page-break-after: auto;
    break-after: auto;
  }

  .print-page-break {
    display: block;
    border: 0;
    margin: 0;
    padding: 0;
    height: 0;
    page-break-after: always;
    break-after: page;
  }

  .badge {
    width: var(--badge-w);
    height: var(--badge-h);
    min-height: 0;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .head {
    border-bottom: 0.4mm solid #d8ecff !important;
    box-shadow: inset 0 -0.4mm 0 #d8ecff;
  }

  .no-print {
    display: none !important;
  }

  .badge-toolbar {
    display: none !important;
  }
}
</style>

<style>
@media print {
  body.badges-print-mode * {
    visibility: hidden !important;
  }

  body.badges-print-mode .badge-print-root,
  body.badges-print-mode .badge-print-root * {
    visibility: visible !important;
  }

  body.badges-print-mode .badge-print-root {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  body.badges-print-mode .badge-toolbar {
    display: none !important;
  }

  body.badges-print-mode.single-badge-print-mode .badge-print-root .badge {
    display: none !important;
  }

  body.badges-print-mode.single-badge-print-mode .badge-print-root .badge.is-print-target {
    display: grid !important;
  }

  body.badges-print-mode.single-badge-print-mode .badge-print-root .print-section {
    display: flex !important;
    justify-content: center !important;
  }

  body.badges-print-mode.single-badge-print-mode .badge-print-root .print-page {
    display: block !important;
    border: 0 !important;
    height: auto !important;
    min-height: 0 !important;
    width: auto !important;
    padding: 0 !important;
    page-break-after: auto !important;
    break-after: auto !important;
  }

  body.badges-print-mode.single-badge-print-mode .badge-print-root .print-page-break {
    display: none !important;
  }

  body.badges-print-mode .badge-print-root .card {
    border: 0 !important;
    box-shadow: none !important;
    margin: 0 !important;
  }

  body.badges-print-mode .badge-print-root .card-body {
    padding: 0 !important;
  }
}
</style>
